import { useSelector } from 'react-redux';
import { getCookieByName } from '../utils/functions';

export function usePrismPrice() {
  const prismPriceCookie = getCookieByName('prismPrice', false);

  const prismPrice = useSelector(
    (state: any) => state.config?.prescriptionModule?.prismPrice
  );

  if (prismPriceCookie !== null && prismPriceCookie !== undefined) {
    window.rxcBrain.prismPrice = prismPriceCookie;
    return prismPriceCookie;
  }
  if (prismPrice !== null && prismPrice !== undefined) {
    window.rxcBrain.prismPrice = prismPrice;
    return prismPrice;
  }
  return false;
}
